/**
 * Cart Drawer Auto-Open after Redirect
 * Deschide drawer-ul după ce am fost redirecționați de la /cart
 */

(function() {
  // Verifică dacă trebuie să deschidem drawer-ul (după redirect)
  if (sessionStorage.getItem('openCartDrawer') === 'true') {
    console.log('[CART-REDIRECT] Opening drawer after redirect...');
    sessionStorage.removeItem('openCartDrawer');
    
    // Așteaptă ca DOM-ul să fie gata
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openCartDrawer);
    } else {
      // DOM deja gata, așteaptă puțin pentru cart-drawer să fie inițializat
      setTimeout(openCartDrawer, 100);
    }
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (!cartDrawer) {
      console.warn('[CART-REDIRECT] Cart drawer not found, retrying...');
      // Retry după 200ms (max 3 încercări)
      if (!openCartDrawer.retries) openCartDrawer.retries = 0;
      if (openCartDrawer.retries < 3) {
        openCartDrawer.retries++;
        setTimeout(openCartDrawer, 200);
      }
      return;
    }
    
    console.log('[CART-REDIRECT] Opening cart drawer...');
    
    // Deschide drawer-ul
    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      // Fallback: adaugă clasa is-open manual
      cartDrawer.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      
      // Trigger update pentru progress bar
      if (typeof cartDrawer.updateProgressBarOnOpen === 'function') {
        cartDrawer.updateProgressBarOnOpen();
      }
    }
  }
})();